export default "__VITE_ASSET__t0wy2u6P__"